import {
  CREATE_CLIENT,
  CREATE_CLIENT_FAILURE,
  CREATE_CLIENT_SUCCESS,
  DELETE_CLIENT,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_SUCCESS,
  GET_CLIENTS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_SUCCESS,
  GET_SINGLE_CLIENT,
  GET_SINGLE_CLIENT_FAILURE,
  GET_SINGLE_CLIENT_SUCCESS,
  UPDATE_CLIENT,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_SUCCESS,
} from "./actionTypes";

const initialState = {
  clients: [],
  singleClient: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const clients = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENTS:
      return {
        ...state,
        loading: true,
      };

    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload,
        loading: false,
      };

    case GET_CLIENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case GET_SINGLE_CLIENT:
      return {
        ...state,
        loading: true,
      };

    case GET_SINGLE_CLIENT_SUCCESS:
      return {
        ...state,
        singleClient: action.payload,
        loading: false,
      };

    case GET_SINGLE_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case CREATE_CLIENT:
      return {
        ...state,
        loading: true,
      };

    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: [...state.clients, action.payload],
        loading: false,
      };

    case CREATE_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case UPDATE_CLIENT:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.map((client) =>
          client._id === action.payload._id ? action.payload : client
        ),
        loading: false,
      };

    case UPDATE_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case DELETE_CLIENT:
      return {
        ...state,
        loading: true,
      };

    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        clients: state.clients.filter(
          (client) => client._id !== action.payload?.id
        ),
        loading: false,
      };

    case DELETE_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default clients;
